import useScrollDepth from "@/hooks/useScrollDepth";

// スクロール深度計測用の副作用専用コンポーネント（描画はしない）
export default function ScrollDepthTracker({ label = "" }) {
  useScrollDepth(label);
  return null;
}
